export default "__VITE_ASSET__DMmp_4ZK__"